import * as React from "react";
const ShopIcon = (props) => (
  <svg
    width={32}
    height={33}
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4}>
      <path
        d="M28.4933 15.4114V23.3981C28.4933 27.0781 25.5066 30.0648 21.8266 30.0648H10.1733C6.49326 30.0648 3.50659 27.0781 3.50659 23.3981V15.5048C4.51993 16.5981 5.95992 17.2248 7.51993 17.2248C9.19992 17.2248 10.8133 16.3848 11.8266 15.0381C12.7333 16.3848 14.2799 17.2248 15.9999 17.2248C17.7066 17.2248 19.2266 16.4248 20.1466 15.0914C21.1733 16.4114 22.7599 17.2248 24.4133 17.2248C26.0266 17.2248 27.4933 16.5714 28.4933 15.4114Z"
        fill="#344054"
      />
      <path
        d="M28.4933 15.4114V23.3981C28.4933 27.0781 25.5066 30.0648 21.8266 30.0648H10.1733C6.49326 30.0648 3.50659 27.0781 3.50659 23.3981V15.5048C4.51993 16.5981 5.95992 17.2248 7.51993 17.2248C9.19992 17.2248 10.8133 16.3848 11.8266 15.0381C12.7333 16.3848 14.2799 17.2248 15.9999 17.2248C17.7066 17.2248 19.2266 16.4248 20.1466 15.0914C21.1733 16.4114 22.7599 17.2248 24.4133 17.2248C26.0266 17.2248 27.4933 16.5714 28.4933 15.4114Z"
        fill="url(#paint0_linear_3639_300871)"
      />
      <path
        d="M28.4933 15.4114V23.3981C28.4933 27.0781 25.5066 30.0648 21.8266 30.0648H10.1733C6.49326 30.0648 3.50659 27.0781 3.50659 23.3981V15.5048C4.51993 16.5981 5.95992 17.2248 7.51993 17.2248C9.19992 17.2248 10.8133 16.3848 11.8266 15.0381C12.7333 16.3848 14.2799 17.2248 15.9999 17.2248C17.7066 17.2248 19.2266 16.4248 20.1466 15.0914C21.1733 16.4114 22.7599 17.2248 24.4133 17.2248C26.0266 17.2248 27.4933 16.5714 28.4933 15.4114Z"
        fill="url(#paint1_linear_3639_300871)"
      />
    </g>
    <path
      d="M19.9866 1.89111H11.9865L10.9999 11.7044C10.9199 12.6111 11.0532 13.4644 11.3866 14.2378C12.1599 16.0511 13.9732 17.2244 15.9999 17.2244C18.0532 17.2244 19.8266 16.0778 20.6266 14.2511C20.8666 13.6778 21.0132 13.0111 21.0266 12.3311V12.0778L19.9866 1.89111Z"
      fill="#344054"
    />
    <path
      d="M19.9866 1.89111H11.9865L10.9999 11.7044C10.9199 12.6111 11.0532 13.4644 11.3866 14.2378C12.1599 16.0511 13.9732 17.2244 15.9999 17.2244C18.0532 17.2244 19.8266 16.0778 20.6266 14.2511C20.8666 13.6778 21.0132 13.0111 21.0266 12.3311V12.0778L19.9866 1.89111Z"
      fill="url(#paint2_linear_3639_300871)"
    />
    <path
      d="M19.9866 1.89111H11.9865L10.9999 11.7044C10.9199 12.6111 11.0532 13.4644 11.3866 14.2378C12.1599 16.0511 13.9732 17.2244 15.9999 17.2244C18.0532 17.2244 19.8266 16.0778 20.6266 14.2511C20.8666 13.6778 21.0132 13.0111 21.0266 12.3311V12.0778L19.9866 1.89111Z"
      fill="url(#paint3_linear_3639_300871)"
    />
    <g opacity={0.6}>
      <path
        d="M29.8134 11.2511L29.4268 7.55778C28.8668 3.53111 27.0401 1.89111 23.1334 1.89111H18.0134L19.0001 11.8911C19.0134 12.0244 19.0268 12.1711 19.0268 12.4244C19.1068 13.1178 19.3201 13.7578 19.6401 14.3311C20.6001 16.0911 22.4668 17.2244 24.4134 17.2244C26.1868 17.2244 27.7868 16.4378 28.7868 15.0511C29.5868 13.9844 29.9468 12.6378 29.8134 11.2511Z"
        fill="#344054"
      />
      <path
        d="M29.8134 11.2511L29.4268 7.55778C28.8668 3.53111 27.0401 1.89111 23.1334 1.89111H18.0134L19.0001 11.8911C19.0134 12.0244 19.0268 12.1711 19.0268 12.4244C19.1068 13.1178 19.3201 13.7578 19.6401 14.3311C20.6001 16.0911 22.4668 17.2244 24.4134 17.2244C26.1868 17.2244 27.7868 16.4378 28.7868 15.0511C29.5868 13.9844 29.9468 12.6378 29.8134 11.2511Z"
        fill="url(#paint4_linear_3639_300871)"
      />
      <path
        d="M29.8134 11.2511L29.4268 7.55778C28.8668 3.53111 27.0401 1.89111 23.1334 1.89111H18.0134L19.0001 11.8911C19.0134 12.0244 19.0268 12.1711 19.0268 12.4244C19.1068 13.1178 19.3201 13.7578 19.6401 14.3311C20.6001 16.0911 22.4668 17.2244 24.4134 17.2244C26.1868 17.2244 27.7868 16.4378 28.7868 15.0511C29.5868 13.9844 29.9468 12.6378 29.8134 11.2511Z"
        fill="url(#paint5_linear_3639_300871)"
      />
    </g>
    <g opacity={0.6}>
      <path
        d="M8.78669 1.89111C4.86669 1.89111 3.05335 3.53111 2.48002 7.59778L2.12002 11.2644C1.98669 12.6911 2.37336 14.0778 3.21336 15.1578C4.22669 16.4778 5.78669 17.2244 7.52002 17.2244C9.46669 17.2244 11.3334 16.0911 12.28 14.3578C12.6267 13.7578 12.8534 13.0644 12.92 12.3444L13.96 1.90445H8.78669V1.89111Z"
        fill="#344054"
      />
      <path
        d="M8.78669 1.89111C4.86669 1.89111 3.05335 3.53111 2.48002 7.59778L2.12002 11.2644C1.98669 12.6911 2.37336 14.0778 3.21336 15.1578C4.22669 16.4778 5.78669 17.2244 7.52002 17.2244C9.46669 17.2244 11.3334 16.0911 12.28 14.3578C12.6267 13.7578 12.8534 13.0644 12.92 12.3444L13.96 1.90445H8.78669V1.89111Z"
        fill="url(#paint6_linear_3639_300871)"
      />
      <path
        d="M8.78669 1.89111C4.86669 1.89111 3.05335 3.53111 2.48002 7.59778L2.12002 11.2644C1.98669 12.6911 2.37336 14.0778 3.21336 15.1578C4.22669 16.4778 5.78669 17.2244 7.52002 17.2244C9.46669 17.2244 11.3334 16.0911 12.28 14.3578C12.6267 13.7578 12.8534 13.0644 12.92 12.3444L13.96 1.90445H8.78669V1.89111Z"
        fill="url(#paint7_linear_3639_300871)"
      />
    </g>
    <path
      d="M15.1332 22.4381C13.4399 22.6114 12.1599 24.0514 12.1599 25.7581V30.0648H19.8266V26.2248C19.8399 23.4381 18.1999 22.1181 15.1332 22.4381Z"
      fill="#344054"
    />
    <path
      d="M15.1332 22.4381C13.4399 22.6114 12.1599 24.0514 12.1599 25.7581V30.0648H19.8266V26.2248C19.8399 23.4381 18.1999 22.1181 15.1332 22.4381Z"
      fill="url(#paint8_linear_3639_300871)"
    />
    <path
      d="M15.1332 22.4381C13.4399 22.6114 12.1599 24.0514 12.1599 25.7581V30.0648H19.8266V26.2248C19.8399 23.4381 18.1999 22.1181 15.1332 22.4381Z"
      fill="url(#paint9_linear_3639_300871)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3639_300871"
        x1={3.50659}
        y1={15.0381}
        x2={16.7798}
        y2={37.1091}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C99FFF" />
        <stop offset={1} stopColor="#981ED2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3639_300871"
        x1={3.5062}
        y1={30.0647}
        x2={16.7794}
        y2={7.99356}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4A879A" />
        <stop offset={1} stopColor="#C5EDF5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3639_300871"
        x1={10.9773}
        y1={1.89111}
        x2={25.0368}
        y2={11.1055}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C99FFF" />
        <stop offset={1} stopColor="#981ED2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3639_300871"
        x1={10.9771}
        y1={17.2244}
        x2={25.0367}
        y2={8.00987}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4A879A" />
        <stop offset={1} stopColor="#C5EDF5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3639_300871"
        x1={18.0134}
        y1={1.89111}
        x2={32.8441}
        y2={13.3305}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C99FFF" />
        <stop offset={1} stopColor="#981ED2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3639_300871"
        x1={18.0132}
        y1={17.2244}
        x2={32.844}
        y2={5.78484}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4A879A" />
        <stop offset={1} stopColor="#C5EDF5" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3639_300871"
        x1={2.09424}
        y1={1.89111}
        x2={16.9371}
        y2={13.3774}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C99FFF" />
        <stop offset={1} stopColor="#981ED2" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3639_300871"
        x1={2.09405}
        y1={17.2244}
        x2={16.937}
        y2={5.73803}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4A879A" />
        <stop offset={1} stopColor="#C5EDF5" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3639_300871"
        x1={12.1599}
        y1={22.3911}
        x2={19.8336}
        y2={30.0579}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C99FFF" />
        <stop offset={1} stopColor="#981ED2" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_3639_300871"
        x1={12.1598}
        y1={30.0647}
        x2={19.8335}
        y2={22.3979}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4A879A" />
        <stop offset={1} stopColor="#C5EDF5" />
      </linearGradient>
    </defs>
  </svg>
);
export default ShopIcon;
